import { focusMainTransiently } from "./focus-main";

export function announceGateLift(message: string, region: HTMLElement | null): void {
  const active = document.activeElement;
  const claimed = active !== null && active !== document.body;
  if (!claimed && focusMainTransiently(message)) return;
  if (region !== null) region.textContent = message;
}

export function clearGateLiftAnnouncement(region: HTMLElement | null): void {
  if (region !== null) region.textContent = "";
}
